import React, {CSSProperties} from 'react';
import {propsToCSS} from "../css";
import {merge} from 'lodash';

export function Group({children, ...props}: {
  children?: any
} & BasicElementProps) {

  return <div {...propsToCSS(props)}>
    {children}
  </div>;
}

export interface BasicElementProps {
  layout: {
    wrap: boolean,
    grow: string,
    basis: string
  },

  style: CSSProperties,

  class: string

}

export const BASIC_ELEMENT_SCHEMA = {
  type: 'object',
  properties: {
    layout: {

      type: 'object',

      properties: {
        wrap: {
          type: 'boolean',
        },
        grow: {
          type: 'string',
        },
        basis: {
          type: 'string',
        }
      }
    },

    style: {
      type: 'object',
      'x-editor-collapsed': true,
      properties: {
        flex: {type: 'string'},
        flexGrow: {type: 'number'}
      }
    },

    class: {type: 'string'}

  }
};

export const CONTAINER_SCHEMA = merge({
  properties: {
    layout: {
      properties: {
        flow: {
          type: 'string',
          enum: ['horizontal', 'vertical'],
        }
      }
    }
  }
}, BASIC_ELEMENT_SCHEMA);

Group.schema = {

  ...CONTAINER_SCHEMA

};